import { useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { InicioPage, MetabasePage, NuevaONGPage, ContactosONGPage, TramitacionesPage, InformesPage, TableroPage, TablerosAdminPage, MapasPage, ApiKeysPage, VersionHistoryPage, RecuperarObrasPage, BaseMatrizPage, CalendarioPage, AnalisisPagosPage, ObrasSinPagosPage, GestionNotificacionesPage, ChatHistorialPage, InformeGestionPage, InformeOrganizacionesPage, IntervencionClubesDeportivosPage, DashboardMonitoreoPage, CicloDeVidaPage, CicloDeVidaV2Page, CircuitoContactosPage, GestionUsuariosPage, AlertasMejoramientosPage, AlertasObrasPage, SeguimientoEventosPage } from '../pages';
//import { MetabasePage } from '../pages/MetabasePage';
//import { NuevaONGPage } from '../pages/NuevaONGPage';
import { LayoutPriv } from '../components/LayoutPriv';
import { AuthContext } from '../context/authContext';
import { SoloAdminRoute } from './SoloAdminRoute';

export const PrivateRoutes = () => {

    const auth = useContext(AuthContext)
    const {user} = useContext(AuthContext)

    return (
        <LayoutPriv>
            <div  className="flex flex-col flex-1 bg-white dark:bg-gray-900 dark:text-white">
                <Routes>
                    
                    <Route path='inicio' element={<InicioPage />} />
                    <Route path='metabase' element={<MetabasePage />} />
                    <Route path='nuevaONG' element={<NuevaONGPage />} />
                    <Route path='contactos-ong' element={<ContactosONGPage />} />
                    <Route path='tramitaciones' element={<TramitacionesPage />} />
                    <Route path='informes' element={<InformesPage />} />
                    {/* Tableros: el nuevo (era V2) es el que ve todo el mundo */}
                    <Route path='tableros' element = {<TablerosAdminPage />} />
                    {/* El tablero anterior queda de respaldo y es solo admin.
                        Va con guard de ruta y no solo con el link del menu de
                        admin, asi que tampoco entra escribiendo la URL. */}
                    <Route path='tableros-respaldo' element={<SoloAdminRoute><TableroPage /></SoloAdminRoute>} />
                    {/* El tablero nuevo se('/', '/tableros') antes. La ruta vieja
                        se deja redirigiendo para los links ya compartidos. */}
                    <Route path='tableros-v2' element={<Navigate to='/tableros' replace />} />
                    <Route path='mapas' element={<MapasPage />} />
                    <Route path='api-keys' element={<ApiKeysPage />} />
                    <Route path='versiones' element={<VersionHistoryPage />} />
                    <Route path='recuperar-obras' element={<RecuperarObrasPage />} />
                    <Route path='base-matriz' element={<BaseMatrizPage />} />
                    <Route path='calendario' element={<CalendarioPage />} />
                    <Route path='analisis-pagos' element={<AnalisisPagosPage />} />
                    <Route path='obras-sin-pagos' element={<ObrasSinPagosPage />} />
                    <Route path='gestion-notificaciones' element={<GestionNotificacionesPage />} />
                    <Route path='chat-historial' element={<ChatHistorialPage />} />
                    <Route path='informe-gestion' element={<InformeGestionPage />} />
                    <Route path='informe-organizaciones' element={<InformeOrganizacionesPage />} />
                    <Route path='informe-clubes-deportivos' element={<IntervencionClubesDeportivosPage />} />
                    <Route path='monitoreo' element={<DashboardMonitoreoPage />} />
                    <Route path='ciclo-de-vida' element={<CicloDeVidaPage />} />
                    <Route path='ciclo-de-vida-v2' element={<CicloDeVidaV2Page />} />
                    <Route path='circuito-contactos' element={<CircuitoContactosPage />} />
                    {/* Solo admin. Va sin <SoloAdminRoute> por consistencia con las
                        otras páginas de admin de esta lista (chat-historial,
                        circuito-contactos): cada una chequea el rol adentro y muestra
                        "Acceso denegado". El backend igual responde 403, así que el rol
                        no queda protegido solo por el front. */}
                    <Route path='gestion-usuarios' element={<GestionUsuariosPage />} />
                    <Route path='alertas-mejoramientos' element={<AlertasMejoramientosPage />} />
                    <Route path='alertas-obras' element={<AlertasObrasPage />} />
                    <Route path='seguimiento-eventos' element={<SeguimientoEventosPage />} />

                    {/* si ya está logueado redirigir a inicio(priv) */}
                    <Route path='*' element={<Navigate to='/inicio' replace />} />

                </Routes>
            </div>

        </LayoutPriv>
    );
};